const DB_NAME = "miEbooks";
const DB_STORE_NAME = 'vuexState';
const DB_VERSION = 1;

const funcs = {
  openDb: function(callback) {
    // console.log("Indexed DB: Opening " + DB_NAME + " (v." + DB_VERSION + ")");
    
    var request = window.indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = function(err) {
      console.error("Indexed DB: Couldn't open the DB", err);
    };

    request.onsuccess = function(event) {
      // console.log("Indexed DB: Opened successfully")
      const db = event.target.result;

      // cache it for if we want to close it
      if(!window.openedIndexedDBS) {
        window.openedIndexedDBS = [];
      }
      window.openedIndexedDBS.push(db)

      callback(db);
    };

    request.onupgradeneeded = function(event) {
      // console.log("Indexed DB: Upgrading for version:", event.oldVersion + " to " + event.newVersion);
      if(event.oldVersion === 0) {
        event.target.result.createObjectStore(DB_STORE_NAME, { keyPath: "user.username" });
      }
    };

  },
  setState: function(db, state) {
    var transaction = db.transaction(DB_STORE_NAME, "readwrite");
    transaction.oncomplete = function(event) {
      // console.log("Indexed DB: State updated", event);
    };
    transaction.onerror = function(event) {
      console.error("Indexed DB: State update failed", event);
    };
    
    var objectStore = transaction.objectStore(DB_STORE_NAME);
    objectStore.put(state);
  },
  clearDB: function(callback) {
    // close DBs before delete
    _.each(window.openedIndexedDBS, db => db.close());

    // delete db request
    var req = window.indexedDB.deleteDatabase(DB_NAME);

    req.onsuccess = function() {
      callback();
    };
    req.onerror = function() {
      callback();
    };
    req.onblocked = function() {
      callback();
    };
  },
  getState: function(db, callback) { 
    var transaction = db.transaction(DB_STORE_NAME, "readonly");    
    var objectStore = transaction.objectStore(DB_STORE_NAME);
    var request = objectStore.getAll();
    
    request.onerror = function(event) {
      console.error("Indexed DB: Couldn't get state, something went wrong.", event);
    };

    request.onsuccess = function(event) {
      const result = event.target.result;
      // console.log("Indexed DB: State fetched", result);
      if(result.length > 0) {
        callback(result[0]);
      } else {
        callback(undefined);
      }
    };
  }
}

export default funcs